<script setup lang="ts">
definePageMeta({
  custom_meta_data: {
    topic: 'roms',
    message: 'Saya tertarik dengan fitur ROMS KiriminAja'
  }
})

useDefaultMeta({
  title: 'ROMS - Repeat Order Management System | KiriminAja',
  description:
    'ROMS KiriminAja bantu kamu kirim pengingat repeat order, promosi, dan ucapan ke pelanggan langsung lewat WhatsApp — otomatis, tanpa ribet.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa keuntungan menggunakan broadcast WhatsApp ROMS KiriminAja?',
    answer:
      '<p>Dengan broadcast WhatsApp, Anda bisa mengirim pesan promosi, pengingat order ulang atau ucapan spesial ke banyak pelanggan sekaligus — tanpa harus chat satu per satu.</p>'
  },
  {
    question:
      'Apakah bisa menggunakan ROMS KiriminAja walau hanya punya sedikit pelanggan?',
    answer:
      '<p>Ya — ROMS dirancang agar bisnis kecil pun bisa mulai otomatisasi pesan pelanggan. Cukup atur sekali, sistem yang kirim dan kamu tinggal fokus ke bisnis.</p>'
  },
  {
    question: 'Bagaimana cara memulai broadcast WhatsApp ROMS KiriminAja?',
    answer:
      '<p>Daftar akun KiriminAja dan hubungkan nomor WhatsApp Bisnis Anda.<br /><br />Upload data pelanggan Anda.<br />Pilih jenis pesan: reminder pembelian ulang, promosi, atau ucapan.<br />Sistem akan otomatis kirim sesuai jadwal yang Anda tentukan.</p>'
  },
  {
    question:
      'Apakah ada batasan jumlah pelanggan yang bisa saya kirimi pesan?',
    answer:
      '<p>Jika menggunakan WhatsApp Business biasa, tiap daftar broadcast maksimal 256 kontak dan hanya kontak yang menyimpan nomor Anda yang akan menerima pesan. Untuk volume lebih besar, ROMS menawarkan opsi skala lebih lanjut.</p>'
  },
  {
    question:
      'Apakah pesan broadcast saya aman dan tidak dianggap spam oleh pelanggan?',
    answer: '<p>Ya — kuncinya adalah kirim pesan yang relevan.</p>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Bikin Pelanggan Balik Beli Lagi, Otomatis!"
      sub-title="ROMS KiriminAja"
      description="ROMS KiriminAja bantu kamu kirim pengingat repeat order, promosi, dan ucapan ke pelanggan langsung lewat WhatsApp — otomatis, tanpa ribet."
      hero-image="/images/roms-banner-1.webp"
    >
      <template #action>
        <div
          class="flex flex-col sm:items-center sm:flex-row gap-2 lg:gap-4 py-2"
        >
          <UiButton
            :to="
              $utm.utmUrl('/register', {
                redirectTo: '/crm/config?meta_setup=1'
              })
            "
            label="Coba ROMS"
          />
          <UiButton
            :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
            label="Hubungi Kami"
            variant="primaryOutline"
          />
        </div>
      </template>
    </HeroBase>

    <SolusiRomsSection1 />
    <SolusiRomsSection2 />
    <SolusiRomsSection3 />
    <SolusiRomsSection4 />
    <SolusiRomsSection5 />
    <FaqBase :faqs="faqs" />
    <SolusiRomsCta />
  </div>
</template>
